import React from 'react';

export default function NotFound() {
  return <div className="not-found">Purposely Not found (not a bug)</div>;
}



// WEBPACK FOOTER //
// ./src/components/NotFound.jsx